var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$validateText(_vm.data.primary.html))?_c('Section',{attrs:{"width":"sm"}},[_c('div',{staticClass:"custom-html rich-text",domProps:{"innerHTML":_vm._s(_vm.html)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }